module.exports = __webpack_public_path__ + "img/102.a8781b39.svg";